<div
  class="input-field"
  [class.input-field--dark]="darkTheme()"
  [class.input-field--outline]="outlineAppearance()"
  [class.input-field--error]="showError()"
>
  <div class="input-field__container" [class.input-field__container--active]="isActive()">
    <label class="input-field__container__label" [for]="inputId()"
      >{{ label() }}
      @if (isRequired()) {
        <span class="required">*</span>
      }
    </label>

    <ng-content select="input" />
    <ng-content select="textarea" />
    <ng-content select="select" />
    <span></span>
    <ng-content select="button" />
  </div>

  <ng-template [paiInputFieldError]="control" />
</div>
